import React from "react";
import { inject, observer } from "mobx-react";
import AllRecallStore from "../AllRecallStore";

export interface RecallVehicleDetailsProps {
    showRecalls(e:any): void;
}

interface InjectedProps extends RecallVehicleDetailsProps {
  allRecallStore: AllRecallStore;
}

const recallVehicleDetails: React.SFC<RecallVehicleDetailsProps> = (props) => {
  const { allRecallStore } = props as InjectedProps;
  const vehicleRecall = allRecallStore.vehicleRecall;
  return (
    <div className="col-md-8 col-md-offset-2 takataRecall">
      <div className="carDetails">
        <div className="carDetails__wrap">
          <h2 className="carDetails__heading h5">My Vehicle Details</h2>
          &nbsp;
          <h3 className="carDetails__name h3">
            <span className="carDetails__year">
              {" "}
              {vehicleRecall.response.buildYear ? "Model Year " + vehicleRecall.response.buildYear : ""}
            </span>
            <span className="carDetails__make"> SUBARU</span>
            <span className="carDetails__model"> {vehicleRecall.response.vehicleModel}</span>
          </h3>
          <p>
            <span className="carDetails__badge"></span>
            <span className="carDetails__series">
              {vehicleRecall.response.vehicleSeries && vehicleRecall.response.vehicleSeries}
            </span>
            <span className="carDetails__transmission"></span>
            <span className="carDetails__bodyType">
              {" "}
              {vehicleRecall.response.vehicleBodyType && vehicleRecall.response.vehicleBodyType}
            </span>
          </p>
          <div className="carDetails__colour">
            <span className="carDetails__colour__value hidden"></span>
            <p className="carDetails__colour__name">
              {vehicleRecall.response.vehicleColourName && vehicleRecall.response.vehicleColourName}
            </p>
          </div>
          <p className="carDetails__vinRego">VIN: {vehicleRecall.response.vinNumber}</p>
          <p className="carDetails__statusMessage ">
            This vehicle is included in recall(s). If this is your vehicle, please continue to Step 3 to view the
            recall(s) of your Subaru vehicle.
          </p>
          <p>&nbsp;</p>
          <div className="row">
            <div className="carDetails__buttons col-xs-12 noPadding text-center">
              <p>
                <input
                  id="btn primary  confirmCarBtn"
                  type="button"
                  className="btn "
                  value="Yes, this is my car"
                  onClick={(e) => {
                    props.showRecalls(e);
                  }}
                />
              </p>
              <p className="carDetails__textLink ">
                <a href="/update-my-details">This is not my car</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default inject("allRecallStore")(observer(recallVehicleDetails));
